import {getDateFormat, getDateLong} from "../../../../../Apis/functions";
import {CARDS_MODEL, TIME_STATUS} from "../Model/Model";
import {STATUS_MODEL} from "../../../../../enums/statusEnum";
import {
    IconCheckIn,
    IconPendingToValidate,
    IconPendingValidation,
    IconReadyToEnter
} from "../../../../../components/buttons/IconButtons";
import moment from "moment";
import {useNavigate} from "react-router-dom";
import {useDispatch, useSelector} from "react-redux";
import {NotifyHost} from "../../../../../reduxToolkit/Invitation/InvitationApi";
import {toast} from "react-toastify";

/**
 * @Email : azapata@ibl.mx
 * @Author: Ferro Zapata Arnulfo
 * @jobTittle: Full Stack Developer
 *
 */


export const IncomingInvitationBodyApp = ({t,withSearchPendingToComplete, withSearchPendingValidation, withSearchReadyToEnter, withSearchCheckIn}) => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { getUserRestriction }  = useSelector((state) => state.RestrictionSlice);
    /**
     * Determines the time status of a visit based on its scheduled dates and check-in time.
     * @param start
     * @param end
     * @param {string|null} checkIn - The actual check-in time, or null if not checked in.
     * @returns {string} The time status (e.g., 'ON_TIME', 'OVERDUE').
     */
    const getVisitStatusTime = (start, end, checkIn = null) => {
        const now = new Date().getTime();

        // 1. Visit has already finished (Passed)
        if (checkIn !== null) {
            return TIME_STATUS.PASSED;
        }

        // 2. Visit is currently happening (On Time)
        // A visit is On Time if it's within the scheduled window AND the visitor has checked in.
        if (now >= start && now <= end) {
            return TIME_STATUS.ON_TIME;
        }

        // 3. Visit is past its start time but hasn't ended yet (Overdue)
        // A visit is Overdue if it's within the scheduled window but the visitor has NOT checked in.
        if (now > end) {
            return TIME_STATUS.OVERDUE;
        }

        // 4. Visit is upcoming (Due Soon or Upcoming)
        // This case only applies if the current time is before the start time.
        if (now < start) {
            const diffMinutes = Math.floor((start - now) / (1000 * 60));

            // Due Soon (if less than or equal to 30 minutes until start)
            if (diffMinutes <= 30) {
                return TIME_STATUS.DUE_SOON;
            } else {
                // Upcoming (if more than 30 minutes until start)
                return TIME_STATUS.UPCOMING;
            }
        }
        // Default return for any unhandled edge cases (though the logic above is complete)
        return TIME_STATUS.OVERDUE;
    };

    const getUserStatus = (statusId) => {
        return statusId === STATUS_MODEL.ACTIVE ? STATUS_MODEL.ACTIVE : STATUS_MODEL.INACTIVE;
    };

    const columns = [
        { key: CARDS_MODEL.PENDING_TO_COMPLETE, title: 'pending_to_complete', tooltip: 'pending_to_complete_info', items: withSearchPendingToComplete , icon:IconPendingToValidate, buttonName:'complete_registration_process'},
        { key: CARDS_MODEL.PENDING_VALIDATION, title: 'pending_validation', tooltip: 'pending_validation_info', items: withSearchPendingValidation, icon:IconPendingValidation, buttonName:'waiting_for_validation'},
        { key: CARDS_MODEL.READY_TO_ENTER, title: 'ready_to_enter', tooltip: 'ready_to_enter_info', items: withSearchReadyToEnter, icon:IconReadyToEnter, buttonName:'notify_host'},
        { key: CARDS_MODEL.CHECKED_IN, title: 'check_in', tooltip: 'check_in_info', items: withSearchCheckIn, icon:IconCheckIn, buttonName:''}
    ];

    const getInvitationDateText = (invitation) => {
        if (!invitation?.startDate || !invitation?.endDate) return "";

        const startMoment = moment(invitation.startDate);
        const endMoment = moment(invitation.endDate);

        const sameDayMonth = startMoment.format("DD MMM") === endMoment.format("DD MMM");

        const start = getDateFormat(invitation.startDate, false, "DD MMM");
        const end = getDateFormat(invitation.endDate, false, "DD MMM");

        return sameDayMonth ? start : `${start} - ${end}`;
    };

    const handleNotify = (id) => {
        dispatch(NotifyHost(id)).then(({ payload }) => {
            if (payload?.data?.success) {
                toast.success(t('host_notified'));
            }
        });
    };

    return {
        getVisitStatusTime,
        getUserStatus,
        columns,
        getInvitationDateText,
        navigate,
        getUserRestriction,
        handleNotify
    }
}
